import { createGlobalStyle } from "styled-components/macro";
const ELEVATIONS = {
  small: `
      0.5px 1px 1px hsl(var(--shadow-color) / 0.7)
    `,
  medium: `
      1px 2px 2px hsl(var(--shadow-color) / 0.333),
      2px 4px 4px hsl(var(--shadow-color) / 0.333),
      3px 6px 6px hsl(var(--shadow-color) / 0.333)
    `,
  large: `
      1px 2px 2px hsl(var(--shadow-color) / 0.2),
      2px 4px 4px hsl(var(--shadow-color) / 0.2),
      4px 8px 8px hsl(var(--shadow-color) / 0.2),
      8px 16px 16px hsl(var(--shadow-color) / 0.2),
      16px 32px 32px hsl(var(--shadow-color) / 0.2)
    `,
  xLarge: `
    1px 2px 2px hsl(var(--shadow-color) / 0.2),
    2px 4px 4px hsl(var(--shadow-color) / 0.2),
    4px 8px 8px hsl(var(--shadow-color) / 0.2),
    8px 16px 16px hsl(var(--shadow-color) / 0.2),
    16px 32px 32px hsl(var(--shadow-color) / 0.2),
    32px 64px 64px hsl(var(--shadow-color) / 0.2)
  `,
  xXLarge: `
    1px 2px 2px hsl(var(--shadow-color) / 0.1),
    2px 4px 4px hsl(var(--shadow-color) / 0.1),
    4px 8px 8px hsl(var(--shadow-color) / 0.1),
    8px 16px 16px hsl(var(--shadow-color) / 0.1),
    16px 32px 32px hsl(var(--shadow-color) / 0.1),
    32px 64px 64px hsl(var(--shadow-color) / 0.1),
    64px 128px 128px hsl(var(--shadow-color) / 0.1)
  `,
  xXXLarge: `
  1px 2px 2px hsl(var(--shadow-color) / 0.1),
  2px 4px 4px hsl(var(--shadow-color) / 0.1),
  4px 8px 8px hsl(var(--shadow-color) / 0.1),
  8px 16px 16px hsl(var(--shadow-color) / 0.1),
  16px 32px 32px hsl(var(--shadow-color) / 0.1),
  32px 64px 64px hsl(var(--shadow-color) / 0.1),
  64px 128px 128px hsl(var(--shadow-color) / 0.1),
  128px 256px 256px hsl(var(--shadow-color) / 0.1)
`,
};
const GlobalStyle = createGlobalStyle`
    :root {
        --bg-color-primary: ${(p) => (p.theme ? "#FFFFFF" : "#000000")};   
        --bg-color-secondary: ${(p) => (p.theme ? "#F2F2F2" : "#404040")};
        --bg-color-tertiary: ${(p) => (p.theme ? "#DDDDDD" : "#888888")};
        --bg-color-quaternary: ${(p) => (p.theme ? "#CCCCCC" : "#CCCCCC")};

        --bg-highlight-color: ${(p) =>
          p.theme ? "#F2F2F2" : "#d9d9d9"}; //#f7f7f7 #393939
        --font-highlight-color: ${(p) => (p.theme ? "black" : "#F2F2F2")};
        --font-color: ${(p) => (p.theme ? "black" : "white")};
        --shadow-color: 0deg 0% 50%;
        --scrollthumb-color: ${(p) => (p.theme ? "#888888" : "#000000")};

    }

    * {
        margin: 0; 
        padding: 0;
        border: 0;
        box-sizing: border-box;
        font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
        font-size: 100%;
        vertical-align: baseline;
        text-decoration: none;
        color: var(--font-color);
        background: var(--bg-color-primary);
        /* overflow-x: ; */
        transition-property: color, background-color, fill, stroke;
        transition-duration: 1s;
        transition-timing-function: ease-in-out;
        ::selection {
            background: #ffb7b7; /* WebKit/Blink Browsers */
        }
        ::-moz-selection {
            background: #ffb7b7; ; /* Gecko Browsers */
        }

        //scrollbar START
        //scrollbar firefox
        scrollbar-width: thin;          /* "auto" or "thin" */
        scrollbar-color: var(--bg-color-primary) var( --bg-color-secondary);
        //scrollbar all other
        *::-webkit-scrollbar {
            width: 12px;               /* width of the entire scrollbar */
        }

        *::-webkit-scrollbar-track {
            background: var( --bg-color-secondary);        /* color of the tracking area */
        }

        *::-webkit-scrollbar-thumb {
            background-color: var(--scrollthumb-color);    /* color of the scroll thumb */
            border-radius: 20px;       /* roundness of the scroll thumb */
            border: 3px solid var( --bg-color-secondary);  /* creates padding around scroll thumb */
        }
        //scrollbar END
        h1{
            font-size: 10em;
        }

        h2{
            font-size: 5em;
        }

        h3{
            max-width: 400px;
            font-size: 1.5em;
        }

        #about{
            background: var(--bg-color-secondary);
            *{background: var(--bg-color-secondary);}
        }

        #project{
            background: var(--bg-color-tertiary);
            *{ background: var(--bg-color-tertiary);}
            height: auto;

        }
        #contact{
            background: var(--bg-color-quaternary);
            *{
                background: var(--bg-color-quaternary);
                color:black;
            }
            
        }


        .main-content-div{
            height: 100vh;
            width: 100vw;
            padding-top: 10vh;
            margin-top: -1vh;
            padding-left: 20px;
            /* padding-bottom:  5%; */
            //animate elevation
            /* :first-child{

                animation: shadow-grow 10s linear forwards;
                @keyframes shadow-grow {
                    0% {
                        
                }
                25% {
                    box-shadow: ${ELEVATIONS.large};
                        margin:  0px  0px 60px 0px;
                }
                50% {
                    box-shadow: ${ELEVATIONS.xLarge};
                margin:  0px  0px 120px 0px;
                
                }
                75% {
                    box-shadow: ${ELEVATIONS.xXLarge};
                margin:  0px  0px 180px 0px;
                }

                100% {
                    box-shadow: ${ELEVATIONS.xXXLarge};
                margin:  0px  0px 240px 0px;
                }
                }
            }

            :nth-child(2){
                animation: distance-grow 10s linear forwards;
                @keyframes distance-grow {
                    0% {
                        
                }
                25% {
                    font-size: 95%;
                }
                50% {
                    font-size: 90%;

                
                }
                75% {
                    font-size: 85%;

                }

                100% {
                    font-size: 80%;

                }
                }

            } */
            //DESIGN FOR SHADOWS
/*                  
            :first-child{
                box-shadow: ${ELEVATIONS.xXXLarge};
                margin:  0px  0px 240px 0px;
            }

            :nth-child(2){
                box-shadow: ${ELEVATIONS.xXLarge};
                margin:  0px  0px 125px 0px;

            }

            :nth-child(3) {
                box-shadow: ${ELEVATIONS.xLarge};
                margin:  0px  0px 90px 0px;

            }

            :nth-child(4) {
                box-shadow: ${ELEVATIONS.large};
                margin:  0px  0px 30px 0px;

            } */
            
        }
        // CONTACT PAGE START
        .contact-div{
            display: flex;
            flex-direction: column;

            gap: 20px;
            a  {
                display: flex;
                gap: 10px;
                align-items: center;
                width: fit-content;
                cursor: ${(p) =>
                  p.theme
                    ? "url(data:image/svg+xml,%3Csvg%20stroke%3D%22black%22%20fill%3D%22black%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"
                    : "url(data:image/svg+xml,%3Csvg%20stroke%3D%22white%22%20fill%3D%22white%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"};        

                opacity: 0.5;
                font-size: 2em;
                :first-child {
                    padding-top: 20px;
                }
                :hover{
                    opacity: 1;
                }
            }

            
        }
        // CONTACT PAGE END

        .header {
            position: fixed;
            width: 100vw;
            height: 10vh;
            font-size: 2em;
            z-index: 9999;

        }
        .header-div{
            display: flex;
            width: 300px;
            margin-top: 20px; 
            margin-left: 10px;
            gap: 20px;
            justify-content: space-evenly;
        }
        .transparent-btn {
            cursor: ${(p) =>
              p.theme
                ? "url(data:image/svg+xml,%3Csvg%20stroke%3D%22black%22%20fill%3D%22black%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"
                : "url(data:image/svg+xml,%3Csvg%20stroke%3D%22white%22%20fill%3D%22white%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"};            background-color: transparent;
            border-bottom: 3px solid transparent;
            opacity: 0.5;

        }
        .btn-hover:hover{
                border-color: var(--font-color);
                opacity: 1;
        }
        //Animate theme button changes
        .animate-in{
            animation:  animate-in 0.6s linear forwards;
            /* opacity: 0; */
            :hover{
                    border-color: var(--font-color);
                    opacity: 1 !important;

                }
            @keyframes animate-in {
                0% {
                opacity: 0;
                transform: scale(0.5) translate(-100%, 0em);
                }
                50% {
                opacity: 0.8;
                }
                75% {
                opacity: 1;
                
                }
                100% {
                    opacity: 0.5;
                    
                }
            }
            
            
        }
        .animate-out{
            animation: animate-out 0.6s linear;
            opacity: 0;
            @keyframes animate-out {
                0% {
                opacity: 0;
                }
                50% {
                opacity: 0.8;
                }
                75% {
                opacity: 1;
                }
                100% {
                opacity: 0.5;
                transform: scale(0.5) translate(100%, 0em);
                }
            }
        }
    }
    //Project Component START
    .projects-div{
        padding: 4% 0;
        display: flex;
        /* flex-direction: column; */
        gap: 20px;
        align-items: baseline;
    }


    .projectLink{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        
        padding: 10px;
        width: 320px;
        transition: all ease-in-out 1000ms;
        border-radius: 20px;
        box-shadow: ${ELEVATIONS.medium};
        cursor: ${(p) =>
          p.theme
            ? "url(data:image/svg+xml,%3Csvg%20stroke%3D%22black%22%20fill%3D%22black%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"
            : "url(data:image/svg+xml,%3Csvg%20stroke%3D%22white%22%20fill%3D%22white%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"};        
            :hover {
            box-shadow: ${ELEVATIONS.large};
            img{
                box-shadow: ${ELEVATIONS.medium};
            
                :hover{
                    box-shadow: ${ELEVATIONS.large};
                }
            }
        }
        img{
            height: 300px;
            margin: 20px;
            border-radius: 20px;
            transition: all ease-in-out 1000ms;

        }

        h3{
            /* color: var(--font-highlight-color); */
            color: black;

        }

    }
    //SINGLE PROJECT PAGE START
    .single-project-container{
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding-left: 10px;
        padding-top: 10vh;

        a {
            max-width: fit-content;
            font-size: 1.3em;
        }

        h3{
            background: lightgray;
            color: var(--font-color);
            max-width: fit-content;
            padding: 10px;
            border-bottom: 3px solid transparent;

            &:nth-child(4n-3){
                background: var(--bg-color-primary);
                border-color: var(--font-color);

        }
        }
        
        ul{
            /* list-style-type: square; */
            padding-left: 25px;
            li{
            list-style-image: url(data:image/svg+xml,%3Csvg%20stroke%3D%22currentColor%22%20fill%3D%22currentColor%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%2014%2016%22%20height%3D%221em%22%20width%3D%221em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M14%208.77v-1.6l-1.94-.64-.45-1.09.88-1.84-1.13-1.13-1.81.91-1.09-.45-.69-1.92h-1.6l-.63%201.94-1.11.45-1.84-.88-1.13%201.13.91%201.81-.45%201.09L0%207.23v1.59l1.94.64.45%201.09-.88%201.84%201.13%201.13%201.81-.91%201.09.45.69%201.92h1.59l.63-1.94%201.11-.45%201.84.88%201.13-1.13-.92-1.81.47-1.09L14%208.75v.02zM7%2011c-1.66%200-3-1.34-3-3s1.34-3%203-3%203%201.34%203%203-1.34%203-3%203z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E);
            }
            li:nth-child(2n){
                list-style-image: url(data:image/svg+xml,%3Csvg%20stroke%3D%22currentColor%22%20fill%3D%22currentColor%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%20512%20512%22%20height%3D%221em%22%20width%3D%221em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M501.1%20395.7L384%20278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192%20158.1V96L64%200%200%2064l96%20128h62.1l106.6%20106.6c-13.6%2027.8-9.2%2062.3%2013.9%2085.4l117.1%20117.1c14.6%2014.6%2038.2%2014.6%2052.7%200l52.7-52.7c14.5-14.6%2014.5-38.2%200-52.7zM331.7%20225c28.3%200%2054.9%2011%2074.9%2031l19.4%2019.4c15.8-6.9%2030.8-16.5%2043.8-29.5%2037.1-37.1%2049.7-89.3%2037.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4%2074.4-67.9-11.3L334%2098.9l74.4-74.4c6.6-6.6%203.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6%2037.9-28.5%2028.5-41.9%2066.1-41.2%20103.6l82.1%2082.1c8.1-1.9%2016.5-2.9%2024.7-2.9zm-103.9%2082l-56.7-56.7L18.7%20402.8c-25%2025-25%2065.5%200%2090.5s65.5%2025%2090.5%200l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64%20472c-13.2%200-24-10.8-24-24%200-13.3%2010.7-24%2024-24s24%2010.7%2024%2024c0%2013.2-10.7%2024-24%2024z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E);
            }
            li::marker{
            //edit marker color / font-size
            }
        }

        p{
            font-size: 1em;
            width: 50%;
        }
    }

    /* Set your aspect ratio */
    .video-container {
        position: relative;
        overflow: hidden;
        height: 0;
        padding-bottom: 56.25%; /* creates a 16:9 aspect ratio */
    }

    .video-container iframe,
    .video-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
    }

    /* And set the max-width of the parent element */
    .video-wrap {
        width: 100%;
        max-width: 600px;
    }
    //SINGLE PROJECT PAGE END

    .go-back{
        cursor: ${(p) =>
          p.theme
            ? "url(data:image/svg+xml,%3Csvg%20stroke%3D%22black%22%20fill%3D%22black%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"
            : "url(data:image/svg+xml,%3Csvg%20stroke%3D%22white%22%20fill%3D%22white%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%201024%201024%22%20height%3D%221.5em%22%20width%3D%221.5em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M848%20359.3H627.7L825.8%20109c4.1-5.3.4-13-6.3-13H436c-2.8%200-5.5%201.5-6.9%204L170%20547.5c-3.1%205.3.7%2012%206.9%2012h174.4l-89.4%20357.6c-1.9%207.8%207.5%2013.3%2013.3%207.7L853.5%20373c5.2-4.9%201.7-13.7-5.5-13.7z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E), auto"};
    }

    //Project Component END
    html { 
        scroll-behavior: smooth; 
}


    //MEDIA QUERIES START
    @media screen and (max-width: 995px) {
        h1{
            font-size: 8em;
        }

        h2{
            font-size: 3em;
        }

        h3{
            max-width: 400px;
            font-size: 1.5em;
        }
    }

    @media screen and (max-width: 900px) {
        h1{
            font-size: 6em;
        }

        h2{
            font-size: 3em;
        }

        h3{
            max-width: 400px;
            font-size: 1.5em;
        }
    }

    @media screen and (max-width: 605px) {
        h1{
            font-size: 4em;
        }

        h2{
            font-size: 3em;
        }

        h3{
            max-width: 400px;
            font-size: 1.5em;
        }
    }
    @media screen and (max-width: 508px) {
        span{
            font-size: 0.8em;
        }
        .projects-div{

            flex-direction: column;

        }
        main{
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
        }
    }

    @media screen and (max-width: 357px){
        //svg above projects starts showing white line
        /* .main-content-div{
            margin-top: -2.43vh;
        } */
        
    }

    @media screen and (max-width: 412px) {
        h1{
            font-size: 3em;
        }

        h2{
            font-size: 2em;
        }

        h3{
            max-width: 400px;
            font-size: 1.5em;
        }
        span{
            font-size: 0.59em;
        }
    }
    .projectLink{
        width: 290px;
    }
`;

export default GlobalStyle;
